import React from "react";
import {prop} from "ramda";
import {lifecycle} from "recompose";
import PropTypes from "prop-types";
import {DEFINED_PRE_CHECKIN_IMAGE_LIST} from "../../../../state/detail/const";
import PreCheckinPhotoContainer from "./PreCheckinPhoto/PreCheckinPhotoContainer";

const PreCheckinPhotoList = ({
                                 setImageTypeMetaData,
                                 imageVersionList,
                                 uploadCustomerImage,
                                 rotateCustomerImage,
                                 customerId,
                                 skipImages = [],
                             }) => {
    return (
        DEFINED_PRE_CHECKIN_IMAGE_LIST
            .filter((image) => {
                return !skipImages.includes(image.name);
            })
            .map((image, index) => {
                return (
                    <PreCheckinPhotoContainer
                        key={index}
                        preCheckinPhotoIndex={index}
                        image={image}
                        customerId={customerId}
                        setImageTypeMetaData={setImageTypeMetaData}
                        rotateCustomerImage={rotateCustomerImage}
                        uploadCustomerImage={uploadCustomerImage}
                        imageVersionList={imageVersionList[image.name]}
                    />
                )
            })
    )
};

PreCheckinPhotoList.propTypes = {
    customerId: PropTypes.string,
    findImageVersion: PropTypes.func.isRequired,
    uploadCustomerImage: PropTypes.func.isRequired,
    rotateCustomerImage: PropTypes.func.isRequired,
    skipImages: PropTypes.arrayOf(
        PropTypes.oneOf(DEFINED_PRE_CHECKIN_IMAGE_LIST.map(prop('name')))
    ),
}

export default lifecycle({
    componentDidMount() {
        this.props.findImageVersion(this.props.customerId)
    },
})(PreCheckinPhotoList)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/customerPreCheckinImageWidget/components/PreCheckinPhotoList.js